<template>
    <!-- 旅行预订 2  -->
    <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg"
        :right-bg="rightBg" :partition="[7, 5]" />
</template>

<script>
import SubPage from '@/views/components/SubPage.vue'
export default {
    name: 'journey-two',
    components: {
        SubPage
    },
    data() {
        return {
            bg: "/img/pay/0--36.png",
            rightBg: "/img/pay/0--75.png",
        }
    },
    computed: {
        title() {
            return this.$t('journey.title');
        },
        subtitle() {
            return this.$t('journeyTwo.subtitle');
        },
        description() {
            const desc = this.$t('journeyTwo.description');
            return Array.isArray(desc) ? desc : [desc];
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    }
}
</script>